// test1530
(1530 && 0);
